// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollContributionsSummaryRecordDto
 */
export interface IPayrollContributionsSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsSummaryRecordDto
     */
    plan_year_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsSummaryRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsSummaryRecordDto
     */
    total_employee_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsSummaryRecordDto
     */
    total_employer_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsSummaryRecordDto
     */
    total_contributions?: number;
}

/**
 * Check if a given object implements the IPayrollContributionsSummaryRecordDto interface.
 */
export function instanceOfIPayrollContributionsSummaryRecordDto(value: object): value is IPayrollContributionsSummaryRecordDto {
    return true;
}

export function IPayrollContributionsSummaryRecordDtoFromJSON(json: any): IPayrollContributionsSummaryRecordDto {
    return IPayrollContributionsSummaryRecordDtoFromJSONTyped(json, false);
}

export function IPayrollContributionsSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollContributionsSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_year_name': json['plan_year_name'] == null ? undefined : json['plan_year_name'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'total_employee_contributions': json['total_employee_contributions'] == null ? undefined : json['total_employee_contributions'],
        'total_employer_contributions': json['total_employer_contributions'] == null ? undefined : json['total_employer_contributions'],
        'total_contributions': json['total_contributions'] == null ? undefined : json['total_contributions'],
    };
}

export function IPayrollContributionsSummaryRecordDtoToJSON(json: any): IPayrollContributionsSummaryRecordDto {
    return IPayrollContributionsSummaryRecordDtoToJSONTyped(json, false);
}

export function IPayrollContributionsSummaryRecordDtoToJSONTyped(value?: IPayrollContributionsSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_year_name': value['plan_year_name'],
        'plan_name': value['plan_name'],
        'total_employee_contributions': value['total_employee_contributions'],
        'total_employer_contributions': value['total_employer_contributions'],
        'total_contributions': value['total_contributions'],
    };
}

